import { Flex, Text, Box, Spinner } from "@/ui";
import Popover from "@/components/Popover";
import { t } from "@/utils";
import Icon from "@/components/Icon";
import IconButton from "@/components/IconButton";
import CameraList from "@/modules/app/components/CameraList";
import SettingsOutlined from "assets/icons/settings_outlined.svg?react";
import ChangeCameraOutlined from "assets/icons/change_camera_outlined.svg?react";
import CameraOffIcon from "assets/icons/camera_off.svg?react";
import CameraOnIcon from "assets/icons/camera.svg?react";
import Hamburger from "assets/icons/hamburger.svg?react";
import { NavItem } from "./Navbar";

type Props = {
  isPaired: boolean;
  cameraList: MappedCameraInfo[] | null;
  cameraId: string | null;
  changeCamera: Cb<string, Promise<boolean | void>>;
  isCameraOff: boolean;
  loading: boolean;
  disabled: boolean;
  hasError: boolean;
  toggleCameraRecordingMode: Cb;
  openSettings: Cb;
};

const MobileMenu = ({
  isPaired,
  cameraList,
  cameraId,
  changeCamera,
  isCameraOff,
  loading,
  disabled,
  hasError,
  toggleCameraRecordingMode,
  openSettings
}: Props) => {
  const hasItems = isPaired || (cameraList?.length ?? 0) >= 2;
  if (!hasItems) return null;

  return (
    <Popover
      contentProps={{
        py: "8px",
        px: 0
      }}
      body={
        <Box>
          {(cameraList?.length ?? 0) >= 2 && (
            <Flex px="12px" h="48px" alignItems="center">
              <CameraList
                activeCameraId={cameraId}
                cameraList={cameraList}
                changeCamera={changeCamera}
                isDisabled={isCameraOff || loading}
              >
                <NavItem as="div" disabled={isCameraOff}>
                  <Icon fill="on-surface-variant" icon={ChangeCameraOutlined} />
                  <Text ml="1rem" color="on-surface">
                    {t("changeCamera")}
                  </Text>
                </NavItem>
              </CameraList>
            </Flex>
          )}
          {isPaired && (
            <>
              <Flex px="12px" h="48px" alignItems="center">
                <NavItem onClick={toggleCameraRecordingMode} disabled={disabled || hasError}>
                  {loading ? (
                    <Spinner width="24px" height="24px" color="on-surface-variant" />
                  ) : (
                    <Icon fill="on-surface-variant" icon={isCameraOff ? CameraOnIcon : CameraOffIcon} size="24px" />
                  )}
                  <Text ml="1rem" color="on-surface">
                    {isCameraOff ? t("startCamera") : t("pauseCamera")}
                  </Text>
                </NavItem>
              </Flex>
              <Flex px="12px" h="48px" alignItems="center">
                <NavItem onClick={openSettings}>
                  <Icon fill="on-surface-variant" icon={SettingsOutlined} />
                  <Text ml="1rem" color="on-surface">
                    {t("settings")}
                  </Text>
                </NavItem>
              </Flex>
            </>
          )}
        </Box>
      }
    >
      <IconButton icon={Hamburger} fill="on-surface-variant" tooltip={{ label: t("buttons.menu") }} />
    </Popover>
  );
};

export default MobileMenu;
